module.exports = __webpack_public_path__ + "static/media/animaljaw.d5cace3c.png";